import { FactoryProvider } from "@angular/core";
import { EnvironmentStageService } from "../../../../environments";
import { APP_LANGUAGE_TOKEN } from "../default-language-token";
import { StageLanguageModel } from "../../../models";
import { ProductStage } from "../../../constants";

export function provideAppDefaultLanguage(stageLanguages: StageLanguageModel[] | undefined): FactoryProvider {
  return {
    provide: APP_LANGUAGE_TOKEN,
    deps: [EnvironmentStageService],
    useFactory: (stageService: EnvironmentStageService): string | undefined => {
      if (stageLanguages && stageLanguages.length > 0) {
        const filteredStageLanguages = stageLanguages
          .filter((slm: StageLanguageModel) => {
            return slm.countryCode && slm.countryCode.length === 2;
          })
          .map<StageLanguageModel>((slm: StageLanguageModel) => ({
            stage: slm.stage,
            countryCode: slm.countryCode.toLowerCase(),
          }));
        if (stageService.isGAST()) {
          const stageLang = filteredStageLanguages.find((slm: StageLanguageModel) => slm.stage === ProductStage.GAST);
          return stageLang?.countryCode;
        } else if (stageService.isDTZ()) {
          const stageLang = filteredStageLanguages.find((slm: StageLanguageModel) => slm.stage === ProductStage.DTZ);
          return stageLang?.countryCode;
        } else if (stageService.isINL()) {
          const stageLang = filteredStageLanguages.find((slm: StageLanguageModel) => slm.stage === ProductStage.INL);
          return stageLang?.countryCode;
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    },
  };
}
